<template>
  <div class="timer-base">
    <vh-dialog
      :title="$t('host.k_557001')"
      :visible.sync="timerVisible"
      width="296px"
      class="bgimg"
      :before-close="onClose"
    >
      <vh-row class="timer-base-padding">
        <vh-row class="pr">
          <!-- 时间增 -->
          <div class="ml8 button_top">
            <img
              :class="{ opacity: ten_mon == 5 }"
              src="./img/add.png"
              alt=""
              @click="ten_mon != 5 && operationTime('ten_mon', 'add')"
            />
          </div>
          <div class="ml4 button_top">
            <img
              :class="{ opacity: mon == 9 }"
              src="./img/add.png"
              alt=""
              @click="mon != 9 && operationTime('mon', 'add')"
            />
          </div>
          <div class="ml8 button_top">
            <img
              :class="{ opacity: ten_sec == 5 }"
              src="./img/add.png"
              alt=""
              @click="ten_sec != 5 && operationTime('ten_sec', 'add')"
            />
          </div>
          <div class="ml4 button_top">
            <img
              :class="{ opacity: sec == 9 }"
              src="./img/add.png"
              alt=""
              @click="sec != 9 && operationTime('sec', 'add')"
            />
          </div>

          <!-- 时间显示区 -->
          <div class="margin10 bg000 pr setting">
            <div class="line_weight ps"></div>

            <div class="timerbg">
              <vh-input
                maxlength="1"
                v-model="ten_mon"
                @focus="inputClear('ten_mon')"
                @blur="testing('ten_mon')"
              ></vh-input>
            </div>
            <div class="timerbg marl4">
              <vh-input
                maxlength="1"
                v-model="mon"
                @focus="inputClear('mon')"
                @blur="testing('mon')"
              ></vh-input>
            </div>

            <div class="pr sep">
              <span class="ft22 custom-font-barlow">:</span>
            </div>

            <div class="timerbg">
              <vh-input
                maxlength="1"
                v-model="ten_sec"
                @focus="inputClear('ten_sec')"
                @blur="testing('ten_sec')"
              ></vh-input>
            </div>
            <div class="timerbg marl4">
              <vh-input
                maxlength="1"
                v-model="sec"
                @focus="inputClear('sec')"
                @blur="testing('sec')"
              ></vh-input>
            </div>
          </div>

          <!-- 时间减 -->
          <div class="ml8 button_bottom">
            <img
              :class="{ opacity: ten_mon == 0 }"
              src="./img/down.png"
              alt=""
              @click="operationTime('ten_mon')"
            />
          </div>
          <div class="ml4 button_bottom">
            <img
              :class="{ opacity: mon == 0 }"
              src="./img/down.png"
              alt=""
              @click="operationTime('mon')"
            />
          </div>
          <div class="ml8 button_bottom">
            <img
              :class="{ opacity: ten_sec == 0 }"
              src="./img/down.png"
              alt=""
              @click="operationTime('ten_sec')"
            />
          </div>
          <div class="ml4 button_bottom">
            <img
              :class="{ opacity: sec == 0 }"
              src="./img/down.png"
              alt=""
              @click="operationTime('sec')"
            />
          </div>
        </vh-row>
        <!-- 表单部分 -->
        <vh-row class="time_form">
          <vh-col :span="13">
            <span>
              <span class="pr top3">
                <span class="color1a1a1a">{{ $t('host.k_557002') }}</span>
                <vh-tooltip
                  placement="top-start"
                  offset="70"
                  :visible-arrow="false"
                  popper-class="timer_form_transfer-box"
                >
                  <i class="vh-iconfont vh-line-question pr5" style="color: #666"></i>
                  <div slot="content">
                    {{ $t('host.k_557003') }}
                    <br />
                    {{ $t('host.k_557004') }}
                  </div>
                </vh-tooltip>
              </span>
              <vh-switch
                :width="28"
                v-model="form.is_all_show"
                @change="changeAllShow"
                size="mini"
                active-color="#fb3a32"
              ></vh-switch>
            </span>
          </vh-col>
          <vh-col :span="11">
            <span>
              <span class="pr top3">
                <span class="color1a1a1a">{{ $t('host.k_557005') }}</span>
                <vh-tooltip
                  placement="top-end"
                  offset="-40"
                  :visible-arrow="false"
                  popper-class="timer_form_transfer-box"
                >
                  <i class="vh-iconfont vh-line-question pr5" style="color: #666"></i>
                  <div slot="content">
                    {{ $t('host.k_557006') }}
                    <br />
                    {{ $t('host.k_557007') }}
                  </div>
                </vh-tooltip>
              </span>
              <vh-switch
                :width="28"
                v-model="form.is_timeout"
                size="mini"
                active-color="#fb3a32"
              ></vh-switch>
            </span>
          </vh-col>
        </vh-row>
        <vh-col align="center" class="mt20">
          <vh-button round plain @click="onSubmit" class="w120">
            {{ $t('host.k_557008') }}
          </vh-button>
        </vh-col>
      </vh-row>
    </vh-dialog>
  </div>
</template>

<script>
  import { boxEventOpitons } from '@/app-shared/utils/tool.js';
  import { useTimerServer, useRoomBaseServer } from 'middle-domain';
  import regRule from '@/app-shared/utils/reg-rule.js';
  export default {
    name: 'VmpLiveTimerSet',
    data() {
      return {
        form: {
          is_all_show: false,
          is_timeout: false
        },
        timerVisible: false,
        sec: 0,
        ten_sec: 0,
        mon: 0,
        ten_mon: 0
      };
    },
    computed: {
      // 是否工具简单模式（乐乐专属）
      isLeLeInteractMode() {
        return this.$domainStore.state.roomBaseServer?.configList?.['lele_interact_model'];
      },
      // 是否直播带货模式
      isLiveCommerceMode() {
        return this.$domainStore.state.roomBaseServer?.configList?.['live_commerce_model'];
      }
    },
    beforeCreate() {
      this.timerServer = useTimerServer();
    },
    created() {
      this.$emitter.on(this.$EMIT_DEFINE.interact_tools_icon_click, this.triggerIconClick);
    },
    beforeDestroy() {
      this.$emitter.off(this.$EMIT_DEFINE.interact_tools_icon_click, this.triggerIconClick);
    },
    mounted() {
      // this.timerServer.listenMsg();
      // 计时器开始
      this.timerServer.$on('timer_start', temp => {
        console.log(temp, '原始消息');
        this.timerVisible = false;
      });
      // 计时器结束
      this.timerServer.$on('timer_end', () => {
        console.warn('监听到了计时器结束-------');
        this.form = {
          is_all_show: false,
          is_timeout: false
        };
        this.sec = 0;
        this.ten_sec = 0;
        this.mon = 0;
        this.ten_mon = 0;
      });
    },
    methods: {
      triggerIconClick(type) {
        if (type === 'timer') {
          this.openTimerSet();
        }
      },
      openTimerSet() {
        this.timerVisible = true;
      },
      onClose() {
        // this.$emit('disTimer', true);
        if (!this.isLeLeInteractMode && !this.isLiveCommerceMode) {
          window.$middleEventSdk?.event?.send(
            boxEventOpitons(this.cuid, 'emitDisTimerIcon', ['disTimer', false])
          );
        }
        this.timerVisible = false;
      },
      // 表单&时间提交
      onSubmit() {
        console.log(this.form);
        const time = this.ten_sec * 10 + this.sec * 1 + (this.ten_mon * 10 + this.mon * 1) * 60;
        if (time == 0) {
          this.$message.warning(this.$t('host.k_557009'));
          return false;
        }
        this.timerVisible = false;
        this.$emit('showTimerFunc', {
          time: time,
          is_timeout: this.form.is_timeout,
          is_all_show: this.form.is_all_show
        });
        this.timerServer
          .timerCreate({
            duration: time,
            is_all_show: this.form.is_all_show ? 1 : 0,
            is_timeout: this.form.is_timeout ? 1 : 0
          })
          .then(res => {
            console.log(res);
          })
          .catch(err => console.log(err));
      },
      // 时间操作
      operationTime(data, status) {
        if (!status && this[data] == 0) return;
        status == 'add' ? this[data]++ : this[data]--;
      },
      // input检查
      testing(data) {
        if (!regRule.num1.test(this[data])) {
          this[data] = 0;
        } else {
          if ((data == 'ten_sec' || data == 'ten_mon') && this[data] > 5) {
            this[data] = 5;
          }
        }
      },
      // 清空input
      inputClear(data) {
        this[data] = '';
      },
      changeAllShow() {
        if (useRoomBaseServer().state.watchInitData.webinar.no_delay_webinar != 1) {
          this.$message({
            type: 'warning',
            message: this.$t('host.k_557010')
          });
          this.form.is_all_show = false;
          return false;
        }
      }
    }
  };
</script>

<style lang="less">
  @import url(./font_family/numberFont.less);
  .timer_form_transfer-box {
    width: 246px;
    box-sizing: border-box;
  }
  .timer-base {
    .timer-base-padding {
      user-select: none;
      position: relative;
      text-align: center;
    }
    .color1a1a1a {
      color: #1a1a1a;
    }
    .vh-switch__core {
      margin-top: 2px;
      height: 16px;
    }
    .vh-switch__core::after {
      height: 12px;
      width: 12px;
    }
    .vh-switch.is-checked .vh-switch__core::after {
      margin-left: -13px;
    }
    @font-high-light-normal: #fb2626;
    .w120 {
      margin-top: 24px;
      border: 1px solid @font-high-light-normal !important;
      color: @font-high-light-normal !important;
      &:hover {
        color: white !important;
        background: @font-high-light-normal !important;
      }
      &:active {
        color: white !important;
        background: @active-normal !important;
      }
    }
    .margin10 {
      border-radius: 4px;
      text-align: center;
      padding: 8px;
    }
    .bg000 {
      background: #d9d9d9;
    }
    .setting {
      float: left;
    }
    .ft22 {
      font-size: 22px;
    }
    .line_weight {
      border: 1px solid #d9d9d9;
      top: 49%;
      z-index: 999;
      width: 95%;
    }
    .ps {
      position: absolute;
    }
    .pr {
      position: relative;
    }
    .top10 {
      top: 11px;
    }
    // .bgimg .vh-dialog {
    //   background: #fff;
    //   border-radius: 8px;
    // }
    // .bgimg .vh-dialog--center .vh-dialog__body {
    //   padding: 0;
    // }
    // .bgimg .vh-dialog__header {
    //   display: none;
    // }
    .timerbg {
      float: left;
      background: url('./img/timerbg.png');
      background-size: 100% 100%;
      height: 62px;
      width: 50px;
      .vh-input__inner {
        border: 0;
        height: 62px;
        background: transparent;
        color: #262626;
      }
      .vh-input__inner {
        .custom-font-barlow;
        font-size: 44px;
        font-weight: 700;
        text-align: center;
      }
    }
    .sep {
      float: left;
      top: 15px;
      z-index: 1000;
    }
    .marl4 {
      margin-left: 4px;
    }
    .time_form {
      margin-top: 12px;
    }

    .button_top,
    .button_bottom {
      float: left;
      width: 50px;
      text-align: center;
      cursor: pointer;
      user-select: none;
      height: 10px;
      line-height: 10px;
      .opacity {
        opacity: 0.4;
      }
      img {
        vertical-align: top;
      }
    }

    .button_bottom {
      img {
        vertical-align: bottom;
      }
    }
    // .ml6 {
    //   margin-left: 6px;
    // }
    .ml8 {
      margin-left: 8px;
    }
    .ml4 {
      margin-left: 4px;
    }
    .top3 {
      top: 3px;
    }
    .pr5 {
      padding: 0 5px;
    }
  }
</style>
